import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-applepay',
    templateUrl: './applepay.component.html',
    styleUrls: ['./applepay.component.scss'],
    standalone: false
})
export class ApplepayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
